<section class="content dashboard-shell" style="margin-top: 0px">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [title]="'Dashboard'"
        [items]="['Home']"
        [active_item]="'Dashboard'"
      >
      </app-breadcrumb>
    </div>

    <app-church-welcome-widget></app-church-welcome-widget>
    <app-gen-widgets></app-gen-widgets>

    <div class="row">
      <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 mt-4">
        <div class="card h-100 dashboard-panel">
          <div class="header">
            <div class="dashboard-header-row">
              <h2 class="dashboard-title">Members Signup</h2>
            </div>
          </div>
          <div class="body">
            <apx-chart
              *ngIf="barChartOptions"
              [series]="barChartOptions.series"
              [chart]="barChartOptions.chart"
              [dataLabels]="barChartOptions.dataLabels"
              [plotOptions]="barChartOptions.plotOptions"
              [responsive]="barChartOptions.responsive"
              [xaxis]="barChartOptions.xaxis"
              [legend]="barChartOptions.legend"
              [colors]="barChartOptions.colors"
              [tooltip]="barChartOptions.tooltip"
              [fill]="barChartOptions.fill"
            >
            </apx-chart>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 mt-4">
        <div class="card h-100 dashboard-panel">
          <div class="header">
            <div class="dashboard-header-row">
              <h2 class="dashboard-title">Giving Review</h2>
            </div>
            <a
              href="/#/admin/giving/view-offerings"
              class="dashboard-link"
            >
              More Details
              <i class="fas fa-arrow-up-right-from-square"></i>
            </a>
          </div>
          <div class="body">
            <apx-chart
              *ngIf="radialChartOptions"
              [series]="radialChartOptions.radialseries"
              [chart]="radialChartOptions.chart"
              [plotOptions]="radialChartOptions.plotOptions"
              [colors]="radialChartOptions.colors"
              [dataLabels]="radialChartOptions.dataLabels"
              [legend]="{ show: false }"
              [tooltip]="radialChartOptions.tooltip"
            >
            </apx-chart>

            <div class="chart-legend dashboard-legend" *ngIf="radialChartOptions">
              <div class="legend-item">
                <span class="dot dot--primary"></span>
                Offertory
              </div>
              <div class="legend-item">
                <span class="dot dot--accent"></span>
                Project Fund
              </div>
              <div class="legend-item">
                <span class="dot dot--deep"></span>
                Tithe
              </div>
              <div class="legend-item">
                <span class="dot dot--ink"></span>
                Donations
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
